<template>
    <div class="notes">
        <div class="title">Notes</div>
        <b-card class="note">
            <b-form-textarea
                :disabled="readonly"
                class="iuput custom-input"
                v-model="value.notes"
                type="text"
                placeholder="Notes"
                required
            ></b-form-textarea>
        </b-card>
    </div>
</template>

<script>
import Select2 from "v-select2-component";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { BFormGroup, BCard } from "bootstrap-vue";
export default {
    components: {
        Select2,
        BFormGroup,
        BCard,
    },
    props: {
        value: {
            type: Object,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
<style lang="scss" scoped>
.notes {
    //   .select2 {
    //     height: 28px !important;
    //   }
    .notes {
        height: 145px;
        background-color: white;
    }
    .custom-input {
        height: 125px;
        border: none !important;
    }
}
</style>
